<!-- Cropper first, tab strip below it — the order ImageConfigurationComponent uses. -->
<div [ngbNavOutlet]="frameNav"></div>

<div class="minimenu-crop-bar">
  <div ngbNav #frameNav="ngbNav" [(activeId)]="activeFrame" class="nav-tabs"
       (navChange)="onTabChange($event)">
    <ng-container *ngFor="let frame of frames" [ngbNavItem]="frame.key">
      <button ngbNavLink>{{ frame.label }}</button>
      <ng-template ngbNavContent>
        <!-- Sized to the downscaled image, so it can never exceed the modal. -->
        <div class="minimenu-cropper-stage" [style.width.px]="imageWidth"
             [style.height.px]="imageHeight">
          <angular-cropper *ngIf="isStageReady" #frameCropper
                           [cropperOptions]="cropperConfigs[frame.key]" [imageUrl]="imageSource"
                           (crop)="onFrameCrop(frame.key, $event)"
                           (ready)="onCropperReady(frame.key)">
          </angular-cropper>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <!-- Caller's image actions, set apart from the frame choices on the same line. -->
  <ng-content></ng-content>
</div>
